/**
 * Generate a unique client file ID for matching request files to response files.
 * Uses crypto.randomUUID() if available, otherwise falls back to a timestamp-based ID.
 * 
 * @returns A unique string identifier
 */
export function generateClientFileId(): string {
  // Use crypto.randomUUID() if available (Chrome 92+, Firefox 95+, Safari 15.4+, Edge 92+)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  
  // Fallback for older browsers
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}

